export default __webpack_public_path__ + "static/visual_5-d02b7bf24417d6f3354644179b34dfcc.jpg";